import React from "react";
import "./vikas.css";

const VikasKame = () => {
  const works = [
    // ===== आधीच्या फोटोंमधली कामे (पूर्वीची) =====
    { title: "सिमेंट रस्ता", desc: "अंबेडकर नगर ते माताजी मंदिर", amount: "१०.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "हरीजन बस्ती ते प्रकाश बडुक", amount: "५.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "निरंजन बस्ती ते सिंचाई रोड", amount: "५.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "उदय कॉलनी ते संजय हेडगे", amount: "५.०० लाख", year: "2023-24" },
    { title: "सिमेंट रस्ता + पाईपलाइन", desc: "पचकाळा कॉलनी ते सावळा निगाळे", amount: "१०.०० लाख", year: "2023-24" },
    { title: "सिमेंट रस्ता", desc: "गजानन महाराज मंदिर ते वळण", amount: "१०.०० लाख", year: "2023-24" },
    { title: "जलपुरवठा योजना दुरुस्ती", desc: "वॉर्ड क्र. ६", amount: "१५.०० कोटी", year: "2023-24" },
    { title: "प्राथमिक आरोग्य केंद्र दुरुस्ती", desc: "प्रा.आ.के. बेला", amount: "१५.०० लाख", year: "2023-24" },
    { title: "तातडीने कक्ष बांधकाम", year: "2023-24", desc: "प्रा.आ.के. बेला", amount: "१५.०० लाख" },
    { title: "प्रा.आ.केंद्र बेला स्वच्छालय बांधकाम", desc: "प्रा.आ.के. बेला", amount: "५.०० लाख", year: "2023-24" },
    { title: "योगा रूम बांधकाम", desc: "प्रा.आ.के. बेला", amount: "१५.०० लाख", year: "2023-24" },
    { title: "बेला वॉर्ड क्र.९ जि.प. शाळा दुरुस्ती", desc: "वि.प. शाळा केंद्र क्र.०१", amount: "५.०० लाख", year: "2023-24" },
    { title: "पेव्हर ब्लॉक बसविणे", desc: "भीम नगर", amount: "२.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "निरंजन बस्ती ते भारत पाटील", amount: "३.०० लाख", year: "2023-24" },
    { title: "आंगणवाडी केंद्र क्र.०४", desc: "चाईल्ड क्र.५", amount: "८.०० लाख", year: "2023-24" },
    { title: "आंगणवाडी केंद्र क्र.०४", desc: "चाईल्ड क्र.६", amount: "८.०० लाख", year: "2023-24" },
    { title: "मोठी आई माता मंदिर येथे समाजभवन बांधकाम", desc: "बेला वॉर्ड क्र.०५", amount: "१५.०० लाख", year: "2023-24" },
    { title: "रस्ते दुरुस्ती", desc: "वॉर्ड क्र.१ ते ६", amount: "९.५० लाख", year: "2023-24" },
    { title: "रस्ते दुरुस्ती", desc: "वॉर्ड क्र.७ ते १४", amount: "४५.०० लाख", year: "2023-24" },
    { title: "पथदिवे", desc: "जैनपुर परिसर ते पहेलवान चाळ", amount: "३१.२५ लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "कमलाकर चाळ ते बायपास रोड", amount: "४.५० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "सुरज काळवेकर ते मुक्तापुर", amount: "७.०० लाख", year: "2023-24" },
    { title: "सिमेंट रस्ता", desc: "गणेश मंदिर ते सागर कंपाउंड", amount: "३.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "गणेश मंदिर ते राजेंद्र चौक", amount: "७.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "प्रभात नजर ते नजीब मिस्त्री", amount: "१२.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "सुरज काळवेकर ते नवनाथ मेश्या", amount: "७.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "शंकर राजपूत ते प्रशांत मोकल", amount: "१.५० लाख", year: "2023-24" },
    { title: "नळ योजना साहित्य खरेदी", desc: "भूमिगत पाईपलाईन", amount: "२.०० लाख", year: "2023-24" },
    { title: "आंगणवाडी खरेदी", desc: "आंगणवाडी क्र.४ व ५", amount: "१.४४ लाख", year: "2023-24" },
    { title: "कायालय भाडे", desc: "मोहिदा बेकर व मधुलेकर बेकर", amount: "१.९३ लाख", year: "2023-24" },
    { title: "सार्वजनिक स्वच्छालय बांधकाम", desc: "बस थांबा परिसर", amount: "२.२२ लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "नागसेन ते लतीफ पठाण", amount: "२.५० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "गणेश मंदिर ते लक्ष्मी माता मंदिर", amount: "२.५० लाख", year: "2023-24" },
    { title: "कचरा विल्हेवाट कक्ष", desc: "बेला", amount: "२.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "विठ्ठल रुक्मिणी मंदिर ते पांडुरंग हाऊस", amount: "२.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "सुरज काळवेकर ते दौलत धनवडे", amount: "४.७५ लाख", year: "2023-24" },
    { title: "सिमेंट रस्ता", desc: "अंबेडकर नगर", amount: "३.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईपलाईन", desc: "रमाई नगर", amount: "२.०० लाख", year: "2023-24" },
    { title: "पाटबंधारे रस्ता", desc: "चंद्रप लिमिटेड ते भालेराव उमरी", amount: "१०.०० लाख", year: "2023-24" },
    { title: "पाटबंधारे रस्ता", desc: "वीराराम बागवे ते रामभाऊ चौधरी", amount: "१०.०० लाख", year: "2023-24" },
    { title: "सदृढीकरण बांधकाम", desc: "सदृढीकरण बांधकाम", amount: "१०.०० लाख", year: "2023-24" },
    { title: "शिवमंदिर परिसर विकास", desc: "वॉर्ड क्र.०२", amount: "१५.०० लाख", year: "2023-24" },
    { title: "ग्रीन जिम", desc: "वॉर्ड क्र.०५", amount: "१.०० लाख", year: "2023-24" },
    { title: "सामान्य फंड", desc: "वॉर बांधकाम", amount: "४.३५ लाख", year: "2023-24" },
    { title: "जन सुविधा तलाव सौंदर्यीकरण", desc: "ग्रामपंचायत समोरील", amount: "१०.०० लाख", year: "2023-24" },

    // ===== आजच्या नवीन फोटोमधली सर्व कामे (14 वा वित्त आयोग + 15 वा वित्त आयोग) =====
    { title: "रस्ता बांधकाम", desc: "संजय बंजारी ते राजेंद्र कांबळे", amount: "२.८० लाख", year: "2023-24" },
    { title: "भूमिगत पाईप नाली बांधकाम", desc: "इमाम जावेद ते नामदेव चौधरी", amount: "२.०० लाख", year: "2023-24" },
    { title: "भूमिगत पाईप नाली बांधकाम", desc: "परमानंद पाटील ते प्रभाकर वैष्णव", amount: "२.८२ लाख", year: "2023-24" },
    { title: "गटारी बांधकाम", desc: "गांधीनगर ते खास बाग", amount: "४.७६ लाख", year: "2023-24" },
    { title: "भूमिगत पाईप नाली बांधकाम", desc: "शांताबाई कांबळे ते यशवंत धनवडकर", amount: "४.६८ लाख", year: "2023-24" },
    { title: "भूमिगत पाईप नाली बांधकाम", desc: "नारायण रोडे ते नारायण लिमaye", amount: "२.९६ लाख", year: "2023-24" },
    { title: "भूमिगत पाईप नाली बांधकाम", desc: "काशीराम कटारे ते नारायण रोडे", amount: "२.८९ लाख", year: "2023-24" },
    { title: "सोलार बांधकाम", desc: "ग्रामपंचायत", amount: "४.२७ लाख", year: "2023-24" },
    { title: "वैयक्तिक कचरा कुंड्या", desc: "बेला", amount: "३.२५ लाख", year: "2023-24" },
    { title: "जी.पी. शाळा कंप्यूटर खरेदी व इतर साहित्य", desc: "केंद्र क्र.३१/३२ और प्रा.आ.केंद्र बेला", amount: "२.३४ लाख", year: "2023-24" },
    { title: "आंगणवाडी करीता आर ओ खरेदी", desc: "आंगणवाडी केंद्र क्र.१ ते ९", amount: "२.२५ लाख", year: "2023-24" }
  ];

  return (
    <div className="vikas-container">
      <h2 className="vikas-title">विकास कामांचा तपशील (२०२३-२४)</h2>

      <table className="vikas-table">
        <thead>
          <tr>
            <th>अ.क्र.</th>
            <th>कामाचे नाव</th>
            <th>तपशील / स्थान</th>
            <th>रक्कम</th>
            <th>वर्ष</th>
          </tr>
        </thead>
        <tbody>
          {works.map((work, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{work.title}</td>
              <td>{work.desc}</td>
              <td>{work.amount}</td>
              <td>{work.year}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VikasKame;